import React, { useState, useEffect } from "react";

import DashboardLayout from "../DashboardLayout";
import {DashboardNew} from "../../components/DashboardNew.jsx";


export default function NewPositionAndOrderView() {



  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full h-screen overflow-hidden">
        <div className="flex flex-col flex-1 h-full">

             <DashboardNew />
          

         
        </div>
      </div>
    </DashboardLayout>
  );
}
